import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=8fc72ef6&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=8fc72ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc72ef6",
  null
  
)

export default component.exports